import React from "react";
import Slider from "react-slick";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import Checkbox from "@mui/material/Checkbox";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowCircleRightIcon
      className={className}
      style={{ ...style, display: "block", color: "#e95655" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <ArrowCircleLeftIcon
      className={className}
      style={{ ...style, display: "block", color: "#e95655" }}
      onClick={onClick}
    />
  );
}

const CustomSlider = ({ src, data, handleAction }) => {
  var settings = {
    dots: false,
    infinite: false,
    slidesToShow: Math.min(data?.length, 3), // Ensure it never exceeds the data length
    slidesToScroll: Math.min(data?.length, 2),
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    vertical: false,
    verticalSwiping: false,
  };

  if (data?.length === 0) return null;
  return (
    <Slider {...settings} className="pdf-logo-slider">
      {data.map((item) => {
        return (
          <div
            key={item.img}
            className="d-flex align-items-center justify-content-center position-relative"
            onClick={() =>
              handleAction(`https://app.rankspro.io/${item.img}`, item.footer)
            }
          >
            <Checkbox
              checked={src === `https://app.rankspro.io/${item.img}`}
              sx={{
                left: 0,
                top: 0,
                "& .MuiSvgIcon-root": { fontSize: 20 },
              }}
              className="position-absolute p-0"
            />
            <img
              srcSet={`https://app.rankspro.io/${item.img}`}
              src={`https://app.rankspro.io/${item.img}`}
              alt={`https://app.rankspro.io/${item.img}`}
              loading="lazy"
              style={{
                width: "100%",
                height: "60px",
                objectFit: "contain",
              }}
            />
          </div>
        );
      })}
    </Slider>
  );
};

export default CustomSlider;
